import escapeRegexp from "escape-string-regexp";
import type { Plugin, ViteDevServer } from "vite";

/**
 * @internal
 * @experimental
 */
export const watchPackages = (packageNames: string[]): Plugin => {
  return {
    name: "vite-plugin-watch-packages",

    configureServer: (server: ViteDevServer): void => {
      server.watcher.options = {
        ...server.watcher.options,
        ignored: [
          ...(server.watcher.options.ignored !== undefined
            ? Array.isArray(server.watcher.options.ignored)
              ? server.watcher.options.ignored
              : [server.watcher.options.ignored]
            : []),
          ...packageNames.map(
            (packageName) =>
              new RegExp(`node_modules/${escapeRegexp(packageName)}.*`),
          ),
        ],
      };
    },
  };
};
